import React, { useState } from "react";
import {
  IconButton,
  Button,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import NotificationMessage from "../common-components/NotificationMessage";
import moment from "moment";
import { toast } from "react-toastify";

const useStyles = makeStyles(() => ({
  closeicon: {
    textAlign: "right",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 16px",
    backgroundColor: "#00A651",
    fontSize: "18px",
    letterSpacing: "0.07px",
    color: "#fff",
    minHeight: "50px",
  },
  clearAllButton: {
    color: "#fff",
    borderColor: "rgba(255,255,255,0.8)",
    fontSize: "12px",
    fontWeight: 700,
    padding: "4px 10px",
    minWidth: "auto",
    textTransform: "none",
    marginRight: "4px",
  },
}));

interface SidebarPanelProps {
  handleDrawerClose: () => void;
  notification: {
    data: NotificationProps[];
  };
  onDeleteNotification?: (id: number | string) => Promise<boolean>;
  onClearAll?: () => Promise<boolean>;
}

interface NotificationProps {
  messages: string;
  id: number | string;
  created_at: string;
}

const SidebarRegister: React.FC<SidebarPanelProps> = ({
  handleDrawerClose,
  notification,
  onDeleteNotification,
  onClearAll,
}) => {
  const classes = useStyles();
  const [deletingId, setDeletingId] = useState<number | string | null>(null);
  const [clearingAll, setClearingAll] = useState(false);

  const handleDelete = async (id: number | string) => {
    if (!onDeleteNotification || deletingId) return;
    setDeletingId(id);
    const success = await onDeleteNotification(id);
    if (success) {
      toast.success("Notification deleted");
    } else {
      toast.error("Could not delete notification");
    }
    setDeletingId(null);
  };

  const handleClearAll = async () => {
    if (!onClearAll || clearingAll || !notification?.data?.length) return;
    setClearingAll(true);
    const success = await onClearAll();
    if (success) {
      toast.success("All notifications cleared");
    } else {
      toast.error("Could not clear notifications");
    }
    setClearingAll(false);
  };

  return (
    <div>
      <div className={classes.closeicon}>
        <Typography variant="h6" style={{ paddingLeft: "15px" }}>
          All Notification
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          {onClearAll && notification?.data?.length > 0 ? (
            <Button
              variant="outlined"
              size="small"
              className={classes.clearAllButton}
              onClick={handleClearAll}
              disabled={clearingAll}
            >
              {clearingAll ? "Clearing..." : "Clear all"}
            </Button>
          ) : null}
          <IconButton style={{ color: "#fff" }}>
            <CloseIcon onClick={handleDrawerClose} />
          </IconButton>
        </div>
      </div>
      <ul style={{ listStyleType: "none", padding: "0", marginBottom: "0" }}>
        {notification && notification.data.length > 0 ? (
          notification.data.map((item, index) => (
            <NotificationMessage
              key={`notification_${item.id || index}`}
              title="Notification"
              time={moment(new Date(item.created_at)).startOf("minute").fromNow()}
              content={item.messages}
              onDelete={
                onDeleteNotification ? () => handleDelete(item.id) : undefined
              }
              deleting={deletingId === item.id}
            />
          ))
        ) : (
          <li style={{ padding: "10px 15px", borderBottom: "3px solid #CBCBCB", textAlign: "left" }}>
            <span>No notifcations found</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export { SidebarRegister };
